import type { Dictionary } from './en';

/** Turkish (Türkçe). ⚠️ Not natively reviewed — see i18n/index.tsx. */
export const tr: Dictionary = {
    'nav.find': 'Bul',
    'nav.prayer': 'Namaz',
    'nav.cards': 'Kartlar',
    'nav.saved': 'Kayıtlı',
    'nav.main': 'Ana gezinme',
    'nav.skip': 'İçeriğe geç',

    'search.placeholder': '{city} içinde ara',
    'search.label': '{city} içinde mekân ara',
    'search.clear': 'Aramayı temizle',
    'search.matches': '{count} sonuç',
    'search.matches_one': '{count} sonuç',
    'city.choose': 'Şehir seç',
    'city.trust.certified': 'Sertifikalı',
    'city.trust.mixed': 'Kısmen sertifikalı',
    'city.trust.community': 'Topluluktan',

    'filter.label': 'Sonuçları filtrele',
    'filter.eat': 'Yemek',
    'filter.shop': 'Alışveriş',
    'filter.pray': 'Namaz',
    'filter.certifiedOnly': 'Yalnızca sertifikalı',
    'filter.hideExpired': 'Süresi dolanları gizle',
    'filter.nearMe': '2 km içinde',
    'filter.clear': 'Temizle',
    'filter.noneCertified': 'Bu şehirde sertifikalı mekân yok',
    'filter.noneExpired': 'Burada süresi dolmuş sertifika yok',

    'results.count': '{count} mekân',
    'results.count_one': '{count} mekân',
    'results.nearestFirst': ', en yakından başlayarak',
    'results.loading': '{city} yükleniyor…',
    'results.error': '{city} yüklenemedi. Bağlantınızı kontrol edip yeniden deneyin.',
    'results.emptyTitle': 'Bu filtrelere uyan sonuç yok.',
    'results.emptyBody': 'Bir filtreyi kaldırmayı deneyin ya da başka bir ad veya bölge arayın.',
    'results.clearAll': 'Tüm filtreleri temizle',
    'results.heading': '{city} içindeki helal mekânlar',

    'banner.community': 'Sertifikalı değil.',
    'banner.communityBody':
        'Bu {count} kayıt {source} kaynaklıdır. Hiçbir helal sertifikasyon kurumu bunları denetlemedi — sipariş vermeden önce personele sorun.',
    'banner.certified': '{total} mekândan {certified} tanesi geçerli sertifikaya sahip',
    'banner.certifiedBody': ' — veren kurum: {source}.',
    'banner.lapsed': ' {count} tanesinin süresi doldu ve bu şekilde işaretlendi.',
    'banner.lapsed_other': ' {count} tanesinin süresi doldu ve bu şekilde işaretlendi.',
    'banner.mixedTail': ' Geri kalanı topluluk kayıtlarıdır, sertifikalı değildir.',
    'banner.checked': '{source} ile {when} doğrulandı.',

    'assurance.certified': 'Helal sertifikalı',
    'assurance.certified.short': 'Sertifikalı',
    'assurance.certified.detail': 'Mekân, tanınmış bir kurumdan helal sertifikasına sahip.',
    'assurance.certified_kitchen': 'Sertifikalı helal mutfak',
    'assurance.certified_kitchen.short': 'Sertifikalı mutfak',
    'assurance.certified_kitchen.detail': 'Helal olmayan yiyecek de sunan bir mekânın içindeki, ayrılmış ve sertifikalı helal mutfak.',
    'assurance.muslim_friendly': 'Müslümanlara uygun',
    'assurance.muslim_friendly.short': 'Uygun',
    'assurance.muslim_friendly.detail': 'Domuz eti ve alkol sunmadığı sertifikalı, ancak tümüyle helal bir mekân değil.',
    'assurance.muslim_owned': 'Müslüman işletmesi',
    'assurance.muslim_owned.short': 'Müslüman işletmesi',
    'assurance.muslim_owned.detail': 'Müslümanlara ait, üçüncü taraf sertifikası yok.',
    'assurance.self_declared': 'Kendi beyanına göre helal',
    'assurance.self_declared.short': 'Kendi beyanı',
    'assurance.self_declared.detail': 'Mekân helal yiyecek sunduğunu söylüyor. Hiçbir kurum bunu denetlemedi.',
    'assurance.community_reported': 'Topluluk bildirimi',
    'assurance.community_reported.short': 'Topluluk',
    'assurance.community_reported.detail':
        'OpenStreetMap katkıcıları tarafından işaretlendi. Hiçbir kurum sertifikalandırmadı — sipariş vermeden önce personele sorun.',

    'cert.label': 'Helal sertifikası',
    'cert.current': 'Sertifika geçerli',
    'cert.expiring_soon': 'Yakında doluyor',
    'cert.expired': 'Sertifikanın süresi doldu',
    'cert.renewal_pending': 'Yenileme sürüyor',
    'cert.listed': 'Sertifikalı olarak kayıtlı',
    'cert.delisted': 'Kayıttan çıkarıldı',
    'cert.unknown': 'Durum bilinmiyor',
    'cert.reference': 'Belge no',
    'cert.category': 'Kategori',
    'cert.validUntil': 'Geçerlilik',
    'cert.expiredOn': 'Süresi doldu',
    'cert.confirmed': 'Doğrulandı',
    'cert.noEndDate': 'bitiş tarihi yayımlanmıyor',
    'cert.noCertifier': 'Kurum kayıtlı değil',
    'cert.expiredNote': 'Bu sertifikanın süresi doldu. O zamandan beri yenilenmiş olabilir — sipariş vermeden önce mekâna sorun.',
    'cert.delistedNote': 'Bu mekân artık {certifier} kaydında yer almıyor. Sertifikasız kabul edin.',
    'cert.pendingNote': 'Kayıt, bu sertifikanın yenilenmekte olduğunu gösteriyor.',
    'cert.openEndedNote':
        'Bu kurum bitiş tarihi yayımlamıyor. Bir mekân, sertifikası geri alınana kadar kayıtta kalır.',
    'cert.ariaValid': '{date} tarihine kadar geçerli',
    'cert.ariaExpired': '{date} tarihinde doldu',
    'cert.ariaOpen': 'Bitiş tarihi yayımlanmıyor. {when} doğrulandı.',

    'place.back': 'Listeye dön',
    'place.save': 'Kaydet',
    'place.saved': 'Kaydedildi',
    'place.address': 'Adres',
    'place.hours': 'Çalışma saatleri',
    'place.phone': 'Telefon',
    'place.directions': 'Yol tarifi',
    'place.website': 'Web sitesi',
    'place.share': 'Paylaş',
    'place.listedBy': 'Kaydeden: {source}',
    'place.checkedWhen': 'Sertifika {when} kontrol edildi',
    'place.approximate': 'Yaklaşık konum — adres bir binaya eşlenemediği için {district} bölgesine yerleştirildi.',
    'place.theDistrict': 'bölge',
    'place.away': '{distance} uzaklıkta',

    'type.restaurant': 'Restoran',
    'type.cafe': 'Kafe',
    'type.bakery': 'Fırın',
    'type.fast_food': 'Fast food',
    'type.food_court': 'Yemek katı',
    'type.hotel_restaurant': 'Otel restoranı',
    'type.grocery': 'Market',
    'type.butcher': 'Kasap',
    'type.mosque': 'Cami',
    'type.prayer_room': 'Mescit',
    'type.attraction_dining': 'Gezi noktası restoranı',

    'prayer.title': 'Namaz',
    'prayer.needLocation': 'Bulunduğunuz yere göre namaz vakitleri ve kıble yönü için konum erişimine izin verin.',
    'prayer.next': 'Sıradaki',
    'prayer.fajr': 'İmsak',
    'prayer.sunrise': 'Güneş',
    'prayer.dhuhr': 'Öğle',
    'prayer.asr': 'İkindi',
    'prayer.maghrib': 'Akşam',
    'prayer.isha': 'Yatsı',
    'prayer.inHours': '{hours} sa {minutes} dk sonra',
    'prayer.inMinutes': '{minutes} dk sonra',
    'prayer.imminent': 'bir dakikadan az kaldı',
    'prayer.highLatitude':
        'Bu enlemde güneş bugün ufkun yeterince altına inmediği için İmsak ve Yatsı olağan yöntemle hesaplanamıyor. Yerel caminizin vakitlerini izleyin.',
    'prayer.method': 'Hesaplama yöntemi',
    'prayer.methodLabel': 'Yöntem',
    'prayer.asrLabel': 'İkindi',
    'prayer.asrStandard': 'Standart (Şafii, Maliki, Hanbeli)',
    'prayer.asrHanafi': 'Hanefi',
    'prayer.calcNote':
        'Konumunuzdan cihazınızda hesaplanır, bu yüzden çevrimdışı da çalışır. Vakitler yol göstericidir — farklıysa yerel caminizi izleyin.',

    'qibla.title': 'Kıble',
    'qibla.fromNorth': 'kuzeyden',
    'qibla.aria': 'Kıble, gerçek kuzeyden {degrees} derece',
    'qibla.needsPermission': 'Bu cihazın pusula olarak çalışması için izin gerekiyor.',
    'qibla.usecompass': 'Cihaz pusulasını kullan',
    'qibla.noCompass': 'Burada pusula okuması yok. Bir pusulayla gerçek kuzeyden {degrees}° yöne dönün.',

    'cards.title': 'Bunu personele gösterin',
    'cards.type': 'Kart türü',
    'cards.language': 'Dil',
    'cards.halal': 'Helal',
    'cards.vegetarian': 'Vejetaryen',
    'cards.allergies': 'Alerjiler',
    'cards.hint': 'Ekran parlaklığını artırın ve telefonu uzatın.',

    'saved.title': 'Kayıtlı',
    'saved.emptyTitle': 'Henüz kaydedilmiş bir şey yok.',
    'saved.emptyBody': 'Herhangi bir mekândaki yer imine dokunun — çevrimdışı da erişilebilir kalır.',
    'saved.emptyCta': 'Yiyecek bir yer bul',
    'saved.staleOne': 'Kayıtlı {count} mekânın sertifikası artık geçerli değil.',
    'saved.staleOther': 'Kayıtlı {count} mekânın sertifikası artık geçerli değil.',
    'saved.staleBody': ' Sertifikalar kaydettikten sonra dolabilir — gitmeden önce kontrol edin.',
    'saved.remove': '{name} kayıtlılardan çıkar',

    'lang.choose': 'Dil seç',
    'lang.label': 'Dil',

    'time.today': 'bugün',
    'time.yesterday': 'dün',
    'time.daysAgo': '{count} gün önce',
    'time.on': '{date} tarihinde',
};
